// Ensure no usage of `process` module in this file

import { showAlert } from '@/components';
import { handleApiError } from '@/lib/handleApiError';
import axiosInstance from '@/utils/axiosInstance';

// Example of replacing process.env with a direct value or a safer alternative

export const getEstimatedArrivals = async (page, size, search) => {
  try {
    const res = await axiosInstance.get(
      `/SmartProAPI/api/estimated-arrival/get-eta-files?page=${page}&size=${size}&searchTerm=${search}`,
    );
    return res.data;
  } catch (error) {
    handleApiError('error', error.response?.data, error?.response?.status);
    throw error;
  }
};

export const uploadETAFile = async (file, config = {}) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    const res = await axiosInstance.post(
      `/SmartProAPI/api/estimated-arrival/upload`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        ...config,
      },
    );
    showAlert('success', 'File uploaded successfully');
    return res.data;
  } catch (error) {
    handleApiError('error', error.response.data, error?.response?.status);
    throw error;
  }
};

export const unloadETAFileBYId = async (id) => {
  try {
    const res = await axiosInstance.delete(
      `/SmartProAPI/api/estimated-arrival/unload-file?fileId=${id}`,
    );
    showAlert('success', 'File deleted successfully');
    return res.data;
  } catch (error) {
    handleApiError('error', error.response?.data, error?.response?.status);
    throw error;
  }
};

export const downloadETAFile = async (whseList) => {
  try {
    const res = await axiosInstance.post(
      `/SmartProAPI/api/estimated-arrival/export-csv`,
      whseList,
      {
        responseType: 'blob',
      },
    );
    console.log(res);
    return res.data;
  } catch (error) {
    handleApiError('error', error.response?.data, error?.response?.status);
    throw error;
  }
};
